<template>
  <b-overlay :show="loading" opacity="0.99">
    <h6 class="title-pages" v-if="items.length > 0">SERVIÇO</h6>
    <div class="row" v-for="(item, key) in items" :key="key">
      <div class="col-md-1 pt-0 pb-0"></div>
      <div class="col-md-11 pt-0 pb-0">
        DATA DO SERVIÇO {{ moment(item.date).format("DD/MM/YYYY") }}
      </div>
      <div class="col-md-1 d-flex align-items-center justify-content-center">
        <b-form-checkbox
          :id="`service-checkbox-${key}`"
          v-model="item.checked"
          :name="`service-checkbox-${key}`"
          @input="handleChangeCheckbox"
        />
      </div>
      <div class="col-md-11 pt-0 pb-0">
        <div class="row">
          <div class="col-md-6 input-form-required">
            <input
              placeholder="Descrição"
              type="text"
              v-model="item.description"
              class="form-control form-control-sm"
            />
          </div>
          <div class="col-md-2 input-form-required">
            <select disabled class="form-control form-control-sm">
              <option value="CREDITO">CRÉDITO</option>
            </select>
          </div>
          <div class="col-md-4 input-form-required">
            <input
              disabled
              placeholder="Valor"
              type="text"
              class="form-control form-control-sm c-success"
              :value="item.value"
            />
          </div>
          <div class="col-md-3 vue-treeselect-required">
            <treeselect
              :options="finance_configuration_category"
              placeholder="SELECIONE..."
              v-model="item.finance_configuration_category_id"
              noChildrenText="NÃO POSSUI CATEGORIA(S) FILHA(S)"
            />
          </div>
          <div class="col-md-3">
            <select
              v-model="item.finance_configuration_profit_cost_center_id"
              class="form-control form-control-sm"
            >
              <option :value="null">Centro de custo/lucro...</option>
              <option
                v-for="profit_cost_center in finance_configuration_profit_cost_center"
                :key="profit_cost_center.id"
                :value="profit_cost_center.id"
              >
                {{ profit_cost_center.description }}
              </option>
            </select>
          </div>
          <div class="col-md-3">
            <select
              disabled
              v-model="item.finance_client_id"
              class="form-control form-control-sm"
            >
              <option :value="null">Cliente...</option>
              <option
                v-for="client in finance_client"
                :key="client.id"
                :value="client.id"
              >
                {{ client.name }}
              </option>
            </select>
          </div>
          <div class="col-md-3">
            <select
              v-model="item.finance_configuration_payment_methods_id"
              class="form-control form-control-sm"
            >
              <option :value="null">Forma de pagamento...</option>
              <option
                v-for="payment_method in finance_configuration_payment_methods"
                :key="payment_method.id"
                :value="payment_method.id"
              >
                {{ payment_method.description }}
              </option>
            </select>
          </div>
          <div class="col-md-6">
            <vs-select
              class="
                col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12
                pt-0
                pb-0
                pl-0
                pr-0
              "
              placeholder="Tags..."
              multiple
              autocomplete
              v-model="item.finance_configuration_tag_ids"
            >
              <vs-select-item
                v-for="tag in finance_configuration_tag"
                :key="tag.id"
                :text="tag.description"
                :value="tag.id"
              />
            </vs-select>
          </div>
          <div class="col-md-3">
            <select
              v-model="item.cost_type"
              class="form-control form-control-sm"
            >
              <option :value="null">Tipo de custo...</option>
              <option
                v-for="type in cost_types"
                :key="type.value"
                :value="type.value"
              >
                {{ type.description }}
              </option>
            </select>
          </div>
          <div class="col-md-3">
            <select
              v-model="item.cost_appropriation"
              class="form-control form-control-sm"
            >
              <option :value="null">Apropriação de custo...</option>
              <option
                v-for="appropriation in cost_appropriations"
                :key="appropriation.value"
                :value="appropriation.value"
              >
                {{ appropriation.description }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-md-1 pt-0 pb-0"></div>
      <div class="col-md-12 pt-0 pb-0"><hr /></div>
    </div>
    <div v-if="data.length > 0" class="text-right mt-2">
      <h1 class="title-pages text-fourteen">
        TOTAL SERVIÇO: R$ {{ formatPrice(total_value) }}
      </h1>
    </div>
    <ErrorsMessages :errors="errors" />
  </b-overlay>
</template>

<script>
import ErrorsMessages from "../../../../../Components/ErrorsMessages.vue";

import Treeselect from "@riophae/vue-treeselect";

import {
  professionalClassCouncilValue,
  formatPrice,
  formatValueOnKeyUp,
} from "../../../../../../lib/format";

import moment from "moment";

export default {
  name: "Service",

  components: {
    ErrorsMessages,
    Treeselect,
  },

  props: {
    loading: Boolean,
    resident_id: [Number, String],
    data: Array,
    total_value: [Number, String],
    start: String,
    end: String,

    finance_client_id: [Number, String],
    finance_client: Array,
    finance_configuration_payment_methods: Array,
    finance_configuration_category: Array,
    finance_configuration_profit_cost_center: Array,
    finance_configuration_tag: Array,
    cost_types: Array,
    cost_appropriations: Array,
    finance_configuration_category_id: [Number, String],
  },

  data() {
    return {
      headers: [
        { text: "STATUS", value: "status", sortable: false },
        { text: "SERVIÇO", value: "service_description", sortable: false },
        { text: "VALOR", value: "value", sortable: false },
        { text: "TOTAL FINAL", value: "total_value", sortable: false },
      ],

      items: [],

      errors: [],
    };
  },

  watch: {
    data() {
      this.retrieve();
    },

    finance_configuration_category() {
      let financeConfigurationCategoryId = null;
      for (let category of this.finance_configuration_category) {
        if (category.default == 1) {
          financeConfigurationCategoryId = category.id;
        }
      }

      this.items.map((item) =>
        !item.service_finance_configuration_category_id
          ? (item.finance_configuration_category_id =
              financeConfigurationCategoryId)
          : (item.finance_configuration_category_id =
              item.service_finance_configuration_category_id)
      );
    },
  },

  methods: {
    moment,
    formatPrice,
    formatValueOnKeyUp,
    professionalClassCouncilValue,

    handleChangeCheckbox() {
      let { items } = this;

      let checkeds = [];
      for (let item of items) {
        if (item.checked) {
          checkeds.push(item);
        }
      }

      this.$emit("itemsChecked", checkeds);
    },

    retrieve() {
      let { data, finance_client_id, finance_configuration_category_id } = this;

      let items = [];
      for (let item of data) {
        items.push({
          id: item.id,
          description: item.service_description,
          value: formatValueOnKeyUp(String(item.value_sale)),
          finance_configuration_category_id,
          finance_configuration_profit_cost_center_id: null,
          provider_id: null,
          finance_client_id,
          finance_configuration_payment_methods_id: null,
          finance_configuration_tag_ids: [],
          cost_type: null,
          cost_appropriation: null,
          spent_or_gain: "CREDITO",
          type: "SERVICE",
          date: item.date,
          checked: false,
          service_finance_configuration_category_id:
            item.service_finance_configuration_category_id,
        });
      }
      this.items = items;

      let financeConfigurationCategoryId = null;
      for (let category of this.finance_configuration_category) {
        if (category.default == 1) {
          financeConfigurationCategoryId = category.id;
        }
      }

      this.items.map((item) =>
        !item.service_finance_configuration_category_id
          ? (item.finance_configuration_category_id =
              financeConfigurationCategoryId)
          : (item.finance_configuration_category_id =
              item.service_finance_configuration_category_id)
      );

      this.$emit("items", items);
    },
  },
};
</script>